{
  "title": "Notifications",
  "readAll": "Mark all as read",
  "empty": "No notifications yet",
  "emptyUnread": "No new notifications",
  "showRead": "Show read",
  "hideRead": "Hide read",
  "loadFailed": "Could not load notifications",
  "readAllFailed": "Could not mark notifications as read",
  "unnamed": "Unnamed",
  "assigned": "assigned you",
  "mentionedInComment": "mentioned you in a comment",
  "mentionedInDescription": "mentioned you in the description",
  "unread": "Unread notifications",
  "companyUnread": "Unread notifications: {{count}}"
}
